import React from 'react';

import { Modal } from '../../../../../../../components';
import Button from '../../../../../../../components/Button';
import { CircularGreenBox } from '../../../../../../../assets/base64Images/search-user/circular-green-box';
import SquadBoldText from '../../../../../../../components/Text/SquadBoldText';
import SquadRegularText from '../../../../../../../components/Text/SquadRegularText';
import PingFangSemiBoldText from '../../../../../../../components/Text/PingFangSemiBoldText';
import PingFangRegularText from '../../../../../../../components/Text/PingFangRegularText';
import ColumnCenter from '../../../../../../../components/Layout/ColumnCenter';
import RowBetween from '../../../../../../../components/Layout/RowBetween';
import RowCenter from '../../../../../../../components/Layout/RowCenter';
import DividerLine from '../../../../../../../components/DividerLine';
import { closeBlack } from '../../../../../../../assets/Base64Image';
import { getFormatPhoneNumber } from '../../../../../../../lib/utils/utils';

const ConfirmUserModal: React.FC<Props> = ({
  callback,
  onClose,
  isEnglish,
  userName,
  phoneNumber,
  roomNo,
  location,
}) => {
  const contentWidth = 275;
  return (
    <Modal
      style={{ width: contentWidth, minWidth: 'unset', padding: 'unset', paddingBottom: 13, borderRadius: 42 }}
    >
      <ColumnCenter style={{ width: contentWidth }}>
        {/* 图标 */}
        <div>
          <img src={CircularGreenBox} style={{ width: '72px', height: '71px', marginTop: '-35px' }} />
        </div>

        {/* 关闭图标 */}
        <ColumnCenter
          onClick={() => onClose()}
          style={{ padding: '10px', width: '30px', height: '30px', marginLeft: 'auto', marginRight: '10px', marginTop: '-35px' }}
        >
          <img src={closeBlack} style={{ width: '10px', height: '10px' }} />
        </ColumnCenter>

        {
          isEnglish ? (
            <SquadBoldText fontSize={22} lineHeight={26}>
              Confirmation
            </SquadBoldText>
          ) : (
            <PingFangSemiBoldText fontSize={22} lineHeight={26}>
              确认
            </PingFangSemiBoldText>
          )
        }
        {
          isEnglish ? (
            <SquadRegularText fontSize={16} lineHeight={21} textAlign={'center'} marginTop={9} width={235}>
              Please confirm that these
              <br />
              details match the details on the
              <br />
              delivery app or docket.
            </SquadRegularText>
          ) : (
            <PingFangRegularText fontSize={16} lineHeight={23} textAlign={'center'} marginTop={9} width={contentWidth * 0.9}>
              请再次核对一下细节与您手中外卖的订单详情一致，确认后以下收件人会立即收到取餐短信。
            </PingFangRegularText>
          )
        }

        <RowCenter>
          <DividerLine width={contentWidth * 0.9} backgroundColor={'#11202B'} opacity={0.1} marginTop={15} />
        </RowCenter>

        <div style={{ width: contentWidth * 0.9, marginTop: 15 }}>
          {
            isEnglish ? (
              <SquadRegularText fontSize={16} lineHeight={19} opacity={0.4}>
                Name
              </SquadRegularText>
            ) : (
              <PingFangRegularText fontSize={16} lineHeight={22} opacity={0.4}>
                名字
              </PingFangRegularText>
            )
          }
          <SquadBoldText fontSize={16} lineHeight={21} marginTop={3}>
            {userName}
          </SquadBoldText>
        </div>

        {
          phoneNumber && (
            <div style={{ width: contentWidth * 0.9, marginTop: 15 }}>
              {
                isEnglish ? (
                  <SquadRegularText fontSize={16} lineHeight={19} opacity={0.4}>
                    Phone
                  </SquadRegularText>
                ) : (
                  <PingFangRegularText fontSize={16} lineHeight={22} opacity={0.4}>
                    电话
                  </PingFangRegularText>
                )
              }
              <SquadBoldText fontSize={16} lineHeight={21} marginTop={3}>
                {getFormatPhoneNumber(phoneNumber, true, true)}
              </SquadBoldText>
            </div>
          )
        }
        {
          !phoneNumber && (
            <div style={{ width: contentWidth * 0.9, marginTop: 15 }}>
              {
                isEnglish ? (
                  <SquadRegularText fontSize={16} lineHeight={19} opacity={0.4}>
                    Unit No.
                  </SquadRegularText>
                ) : (
                  <PingFangRegularText fontSize={16} lineHeight={22} opacity={0.4}>
                    门牌号
                  </PingFangRegularText>
                )
              }
              <SquadBoldText fontSize={16} lineHeight={21} marginTop={3}>
                {roomNo}
              </SquadBoldText>
            </div>
          )
        }
        <div style={{ width: contentWidth * 0.9, marginTop: 15 }}>
          {
            isEnglish ? (
              <SquadRegularText fontSize={16} lineHeight={19} opacity={0.4}>
                Location
              </SquadRegularText>
            ) : (
              <PingFangRegularText fontSize={16} lineHeight={22} opacity={0.4}>
                地点
              </PingFangRegularText>
            )
          }
          <SquadBoldText fontSize={16} lineHeight={21} marginTop={3}>
            {location}
          </SquadBoldText>
        </div>

        <RowCenter>
          <DividerLine width={contentWidth * 0.9} backgroundColor={'#11202B'} opacity={0.1} marginTop={15} />
        </RowCenter>

        {/* Okay按钮 */}
        <RowBetween style={{ width: contentWidth * 0.9, marginTop: 15, marginBottom: 15 }}>
          <Button
            width={114}
            height={38}
            backgroundColor={'#F44336'}
            borderRadius={60}
            onClick={() => onClose()}
          >
            {
              isEnglish ? (
                <SquadBoldText fontSize={18} color={'#FFFFFF'}>
                  Change
                </SquadBoldText>
              ) : (
                <PingFangSemiBoldText fontSize={18} color={'#FFFFFF'}>
                  更改
                </PingFangSemiBoldText>
              )
            }
          </Button>
          <Button
            width={114}
            height={38}
            backgroundColor={'#00B595'}
            borderRadius={60}
            onClick={() => callback()}
          >
            {
              isEnglish ? (
                <SquadBoldText fontSize={18} color={'#FFFFFF'}>
                  Confirm
                </SquadBoldText>
              ) : (
                <PingFangSemiBoldText fontSize={18} color={'#FFFFFF'}>
                  确认
                </PingFangSemiBoldText>
              )
            }
          </Button>
        </RowBetween>
      </ColumnCenter>
    </Modal>
  );
};

export interface Props {
  onClose: () => void;
  callback: () => void;
  isEnglish: boolean;
  userName: string;
  phoneNumber?: string;
  roomNo: string;
  location: string
}

export default ConfirmUserModal;
